import { useQuery } from '@tanstack/react-query';
import { staffAPI } from '../services/api';

// Months that have finalized payroll and/or uploaded levy bills (HR only).
// Used to anchor the dashboard summary on the latest closed period.
export const usePLCAvailableMonths = () => {
  return useQuery({
    queryKey: ['plc', 'available-months'],
    queryFn: async () => {
      const response = await staffAPI.plcGetAvailableMonths();
      return response.data?.months || [];
    },
    staleTime: 30 * 60 * 1000, // 30 minutes - new months appear once a payroll run closes
    retry: false, // HR-only endpoint; a 403 for non-HR should not be retried
  });
};

// Combined Project Labour Cost (salary + levy + dorm) for a single month.
// This is the heavy aggregation behind the full PLC report; the dashboard
// consumes only its grand totals + source split for an at-a-glance view.
export const usePLCCombinedSummary = (year, month) => {
  return useQuery({
    queryKey: ['plc', 'combined-summary', { year, month }],
    queryFn: async () => {
      const response = await staffAPI.plcGetCombinedReport({ year, month });
      return response.data;
    },
    enabled: !!year && !!month,
    staleTime: 30 * 60 * 1000, // 30 minutes - a closed month's cost does not change often
    retry: false, // HR-only endpoint; a 403 for non-HR should not be retried
  });
};
